const backgroundColors = {
  slicer3D: [160 / 255, 164 / 255, 217 / 255],
};

export default backgroundColors;
